import {QRCodeSVG} from 'qrcode.react';
import React from 'react';

import cn from 'classnames';

import s from './QRCode.module.css';

interface Props {
  qrCodeText: string;
  className?: string;
  url: string;
}

export function QRCode({qrCodeText, className, url}: Props): JSX.Element {
  return (
    <div className={cn(s.root, className)}>
      <div className={s.qrWrapper}>
        <QRCodeSVG value={url} className={s.code} />
      </div>
      <div className={s.tipWrapper}>
        <p className={s.tip}>{qrCodeText}</p>
      </div>
    </div>
  );
}
